export default __webpack_public_path__ + "static/media/card-image7.ffe6ce57.png";